import { ref, watch } from 'vue'

import { defineStore } from 'pinia'

import type { Coordinates } from '@tsyl/karonte/lib/types/coordinates'

export default defineStore('marker', () => {
  const markerCoordinates = ref<Coordinates>({})
  const zoom = ref(3)
  const enableMarker = ref(false)

  watch(enableMarker, (value) => {
    if (!value) {
      markerCoordinates.value = {}
    }
  })

  return { markerCoordinates, enableMarker, zoom }
})
